import {BaseConverter} from '../../base/converters/base-converter.converter';
import {OrdersResearchFilterModel} from '../models/orders-research-filter.model';
import {OrdersResearchFilter} from '../../shared/DTO/ordersResearchFilter';

export class OrdersResearchFilterConverter extends BaseConverter<OrdersResearchFilterModel, OrdersResearchFilter> {
  convertToDto(model: OrdersResearchFilterModel): OrdersResearchFilter {
    if (!model) {
      return undefined;
    }
    return {
      accountCode: model.accountCode,
      activationDataFrom: model.activationDataFrom,
      activationDataTo: model.activationDataTo,
      externalCommonOrdersId: model.externalCommonOrdersId,
      commonOrdersId: model.commonOrdersId,
      applicantTaxCode: model.applicantTaxCode,
      companyName: model.companyName,
      customerCode: model.customerCode,
      filterType: model.filterType,
      holderId: model.holderId,
      holderTaxCode: model.holderTaxCode,
      insertDate: model.insertDate,
      mailboxName: model.mailboxName,
      mailboxNameLike: model.mailboxNameLike,
      name: model.name,
      nickname: model.nickname,
      orderId: model.orderId,
      productTypes: model.productTypes,
      resellerOrderId: model.resellerOrderId,
      surname: model.surname,
      surnameAndName: model.surnameAndName,
      suspendedOrders: model.suspendedOrders,
      taxCode: model.taxCode,
      unit: model.unit,
      userId: model.userId,
      state: model.state,
      emailAddress: model.emailAddress,
      mobileNumber: model.mobileNumber,
      insertOperatorId: model.insertOperatorId,
      iut: model.iut,
      deviceId: model.deviceId
    };
  }

  convertToModel(dto: OrdersResearchFilter): OrdersResearchFilterModel {
    if (!dto) {
      return null;
    }

    let model: OrdersResearchFilterModel = new OrdersResearchFilterModel();
    model.accountCode = dto.accountCode;
    model.activationDataFrom = dto.activationDataFrom;
    model.activationDataTo = dto.activationDataTo;
    model.externalCommonOrdersId = dto.externalCommonOrdersId;
    model.commonOrdersId = dto.commonOrdersId;
    model.applicantTaxCode = dto.applicantTaxCode;
    model.companyName = dto.companyName;
    model.customerCode = dto.customerCode;
    model.filterType = dto.filterType;
    model.holderId = dto.holderId;
    model.holderTaxCode = dto.holderTaxCode;
    model.insertDate = dto.insertDate;
    model.mailboxName = dto.mailboxName;
    model.mailboxNameLike = dto.mailboxNameLike;
    model.name = dto.name;
    model.nickname = dto.nickname;
    model.orderId = dto.orderId;
    model.productTypes = dto.productTypes;
    model.resellerOrderId = dto.resellerOrderId;
    model.surname = dto.surname;
    model.surnameAndName = dto.surnameAndName;
    model.suspendedOrders = dto.suspendedOrders;
    model.taxCode = dto.taxCode;
    model.unit = dto.unit;
    model.userId = dto.userId;
    model.state = dto.state;
    model.emailAddress = dto.emailAddress;
    model.mobileNumber = dto.mobileNumber;
    model.insertOperatorId = dto.insertOperatorId;
    model.iut = dto.iut;
    model.deviceId = dto.deviceId;
    return model;

  }

}
